module.exports = __webpack_public_path__ + "img/index_pic26.2ae1fe4b.png";